
    //数据 state
    const state = {
        template   : { // 场景数据
            num  : 0,
            data : '',
            name : '模板',
            type : 'template',
            resourceType : 'home/template',
        },
        scenes     : { // 场景数据
            num  : 0,
            data : '',
            name : '场景页',
            type : 'scenes',
            resourceType : 12,
        },
        bg         : { // 背景
            num  : 0,
            data : '',
            name : '背景',
            type : 'bg',
            resourceType : 3,
        },
        text       : { // 文字
            num  : 0,
            data : '',
            name : '文字',
            type : 'text',
            resourceType : 16,
        },
        characters : { // 角色
            num  : 0,
            data : '',
            name : '角色',
            type : 'characters',
            resourceType : 14,
        },
        props      : { // 道具
            num  : 0,
            data : '',
            name : '道具',
            type : 'props',
            resourceType : 17,
        },
        gif        : { // 道具
            num  : 0,
            data : '',
            name : 'GIF',
            type : 'gif',
            resourceType : 37,
        },
        shapes     : { // 形状
            num  : 0,
            data : '',
            name : '形状',
            type : 'shapes',
            resourceType : 15,
        },
        sound      : { // 音乐
            num  : 0,
            data : '',
            name : '声音',
            type : 'sound',
            resourceType : 5,
        },
        personal   : { // 个人素材
            num  : 0,
            data : '',
            name : '个人素材',
            type : 'personal',
            resourceType : 'user',
        },
        isGlobalSearch : false,  // 判断是否开启了全局搜索
        noSearchData   : false,
        searchName     : '',
    }

    //获取数据 getters
    const getters = {
        S_Scenes     : state => state.scenes,
        S_Template   : state => state.template,
        S_Bg         : state => state.bg,
        S_Text       : state => state.text,
        S_Characters : state => state.characters,
        S_Props      : state => state.props,
        S_Gif        : state => state.gif,
        S_Shapes     : state => state.shapes,
        S_Sound      : state => state.sound,
        S_Personal   : state => state.personal,
        S_SearchData : state => state,                  // 所有搜索数据
        S_GlobalSearch : state => state.isGlobalSearch, // 判断是否开启搜索
        S_SearchName : state => state.searchName,
    }

    //修改数据 mutations
    const mutations = {
        save_SearchData(state, data){
            if(
                state.searchName == data.data
            ){
                return;
            }

            state.isGlobalSearch = true;
            state.searchName = data.data;

            state.template.num  = 'template' in data ? data.template : 0;
            state.template.data = data.data;

            state.scenes.num  = 'scenes' in data ? data.scenes : 0;
            state.scenes.data = data.data;

            state.bg.num      = 'bg' in data ? data.bg : 0;
            state.bg.data     = data.data;

            state.text.num    = 'text' in data ? data.text : 0;
            state.text.data   = data.data;

            state.props.num   = 'props' in data ? data.props : 0;
            state.props.data  = data.data;

            state.shapes.num  = 'shapes' in data ? data.shapes : 0;
            state.shapes.data = data.data;

            state.gif.num   = 'gif' in data ? data.gif : 0;
            state.gif.data  = data.data;

            state.sound.num   = 'sound' in data ? data.sound : 0;
            state.sound.data  = data.data;

            state.personal.num   = 'user' in data ? data.personal : 0;
            state.personal.data  = data.data;

            state.characters.num  = 'characters' in data ? data.characters : 0;
            state.characters.data = data.data;

            if(
                !state.scenes.num && !state.bg.num    &&
                !state.text.num   && !state.props.num &&
                !state.shapes.num && !state.gif.num   &&
                !state.sound.num  && !state.personal.num &&
                !state.characters.num && !state.template.num
            ){
                state.noSearchData = true;
            }
        },
        save_SearchClose(state, data){
            state.isGlobalSearch      = false;
            state.noSearchData        = false;
            state.searchName          = '';

            state.template.num  = 0;
            state.template.data = '';

            state.scenes.num  = 0;
            state.scenes.data = '';

            state.bg.num      = 0;
            state.bg.data     = '';

            state.text.num    = 0;
            state.text.data   = '';

            state.props.num   = 0;
            state.props.data  = '';

            state.shapes.num  = 0;
            state.shapes.data = '';

            state.gif.num   = 0;
            state.gif.data  = '';

            state.sound.num   = 0;
            state.sound.data  = '';

            state.personal.num   = 0;
            state.personal.data  = '';

            state.characters.num  = 0;
            state.characters.data = '';
        },
    }

    export default {
        state,
        getters,
        mutations
    }



// WEBPACK FOOTER //
// ./src/store/modules/search.js